/**
 * Rewrites our own media hosts to a neutral one, for pages served on a blind
 * share domain.
 *
 * Media URLs are stored absolute in the database (`file.location` from
 * multer-s3), so they carry the origin host into every `<img src>` — visible in
 * the URL itself, no DevTools needed. Rewriting at render time covers rows
 * already written, so no backfill is needed.
 *
 * Only our hosts are rewritten; third-party URLs (external viewers, CDNs) pass
 * through untouched.
 */
const OUR_MEDIA_HOST =
  /^https?:\/\/(?:[a-z0-9-]+\.)*(?:univdiam\.com|univdiam\.[a-z0-9-]+\.digitaloceanspaces\.com)/i

const envTarget = () =>
  (import.meta as unknown as { env?: Record<string, string | undefined> }).env
    ?.VITE_SHARE_MEDIA_DOMAIN

/**
 * ponytail: host swap only. Assumes the neutral host serves the same key paths
 * (a CDN alias of the same Space). Path-style URLs — `.../<bucket>/<key>` — would
 * keep the bucket name in the path; none are written today (forcePathStyle: false).
 */
export const blindMediaUrl = (url?: string | null, target = envTarget()) => {
  if (!url) return ''
  if (!target) return url
  return url.replace(OUR_MEDIA_HOST, target.replace(/\/+$/, ''))
}
